'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { type ButtonProps, buttonVariants, SelectContent, SelectGroup, SelectItem, Select as SelectRoot, SelectSeparator, SelectTrigger } from '@repo/ui';
import { useEffect, useMemo, useState } from 'react';
import { Avatar } from '../Avatar';
import { OptionLabel } from './OptionLabel';
interface SelectProps<T> {
  value: T;
  size?: ButtonProps['size'];
  onChange: (value: T) => void;
  options?: readonly OptionSelect<T>[];
  headerOption?: OptionSelect<T>;
  disabled?: boolean;
  nativeSelect?: boolean;
  triggerClassName?: string;
  buttonVariant?: ButtonProps['variant'];
}
export interface OptionSelect<T> {
  label: string;
  value: T;
  imgUrl?: string;
  disabled?: boolean;
}
const itemClassName = 'pl-xs py-2xs min-h-8 focus:bg-background text-muted-foreground focus:text-foreground data-[state=checked]:text-foreground cursor-pointer rounded-lg text-xs';
export function Select(t0) {
  const $ = _c(58);
  const {
    value,
    onChange,
    options,
    headerOption,
    disabled,
    size: t1,
    nativeSelect: t2,
    triggerClassName,
    buttonVariant: t3
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const nativeSelect = t2 === undefined ? false : t2;
  const buttonVariant = t3 === undefined ? "secondary" : t3;
  const [open, setOpen] = useState(false);
  let t4;
  if ($[0] !== open) {
    t4 = [open];
    $[0] = open;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  useEffect(_temp, t4);
  let t5;
  if ($[2] !== headerOption || $[3] !== options || $[4] !== value) {
    t5 = (headerOption && String(headerOption.value) === String(value) ? headerOption : undefined) ?? options?.find(option => String(option.value) === String(value));
    $[2] = headerOption;
    $[3] = options;
    $[4] = value;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const selectedOption = t5;
  let t6;
  if ($[6] !== headerOption || $[7] !== options) {
    t6 = value_0 => {
      if (headerOption && String(headerOption.value) === value_0) {
        return headerOption.value;
      }
      const option_1 = options?.find(option_0 => String(option_0.value) === value_0);
      return option_1?.value;
    };
    $[6] = headerOption;
    $[7] = options;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const getSelectedValue = t6;
  if (nativeSelect) {
    let t7;
    if ($[9] !== buttonVariant || $[10] !== size || $[11] !== triggerClassName) {
      t7 = cn(buttonVariants({
        variant: buttonVariant,
        size
      }), triggerClassName);
      $[9] = buttonVariant;
      $[10] = size;
      $[11] = triggerClassName;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    const t8 = String(value);
    let t9;
    if ($[13] !== getSelectedValue || $[14] !== onChange) {
      t9 = e => onChange(getSelectedValue(e.target.value) as T);
      $[13] = getSelectedValue;
      $[14] = onChange;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    let t10;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = cn("bg-transparent", "border-none", "cursor-pointer", "outline-none", "w-full", "h-full", "rounded-lg", "[font:inherit]");
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    let t11;
    if ($[17] !== headerOption) {
      t11 = headerOption && <><option value={String(headerOption.value)}>{headerOption.label}</option><option disabled={true}>──────────</option></>;
      $[17] = headerOption;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    let t12;
    if ($[19] !== options) {
      t12 = options?.map(_temp2);
      $[19] = options;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    let t13;
    if ($[21] !== disabled || $[22] !== t11 || $[23] !== t12 || $[24] !== t8 || $[25] !== t9) {
      t13 = <select value={t8} onChange={t9} disabled={disabled} className={t10}>{t11}{t12}</select>;
      $[21] = disabled;
      $[22] = t11;
      $[23] = t12;
      $[24] = t8;
      $[25] = t9;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    let t14;
    if ($[27] !== t13 || $[28] !== t7) {
      t14 = <div className={t7}>{t13}</div>;
      $[27] = t13;
      $[28] = t7;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    return t14;
  }
  const t7 = String(value);
  let t8;
  if ($[30] !== getSelectedValue || $[31] !== onChange) {
    t8 = next => onChange(getSelectedValue(next) as T);
    $[30] = getSelectedValue;
    $[31] = onChange;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] !== buttonVariant || $[34] !== size || $[35] !== triggerClassName) {
    t9 = cn(buttonVariants({
      variant: buttonVariant,
      size
    }), "focus:ring-0", buttonVariant === "secondary" || buttonVariant === "outline" ? "focus:border-border" : "focus:border-transparent", triggerClassName);
    $[33] = buttonVariant;
    $[34] = size;
    $[35] = triggerClassName;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== selectedOption) {
    t10 = selectedOption?.imgUrl && <Avatar src={selectedOption.imgUrl} size="xsmall" />;
    $[37] = selectedOption;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  const t11 = selectedOption?.label;
  let t12;
  if ($[39] !== t10 || $[40] !== t11) {
    t12 = <span className="gap-2xs flex items-center">{t10}{t11}</span>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t12 || $[43] !== t9) {
    t13 = <SelectTrigger variant={null} className={t9}>{t12}</SelectTrigger>;
    $[42] = t12;
    $[43] = t9;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== headerOption) {
    t14 = headerOption && <><SelectItem value={String(headerOption.value)} disabled={headerOption.disabled} className={itemClassName}><OptionLabel imgUrl={headerOption.imgUrl}>{headerOption.label}</OptionLabel></SelectItem><SelectSeparator className="my-xs" /></>;
    $[45] = headerOption;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== options) {
    t15 = options?.map(_temp3);
    $[47] = options;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  if ($[49] !== t14 || $[50] !== t15) {
    t16 = <SelectContent align="end" sideOffset={4} className="bg-popover border-border py-sm max-h-[calc(50svh-var(--spacing-sm))] w-[min(200px,70vw)] min-w-0 rounded-lg border-[0.5px] px-[6px] shadow-lg data-[side=bottom]:translate-y-0 data-[side=top]:translate-y-0 [&>[data-radix-select-viewport]]:min-w-0 [&>[data-radix-select-viewport]]:p-0"><SelectGroup>{t14}{t15}</SelectGroup></SelectContent>;
    $[49] = t14;
    $[50] = t15;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== disabled || $[53] !== t13 || $[54] !== t16 || $[55] !== t7 || $[56] !== t8) {
    t17 = <SelectRoot value={t7} onValueChange={t8} disabled={disabled} onOpenChange={setOpen}>{t13}{t16}</SelectRoot>;
    $[52] = disabled;
    $[53] = t13;
    $[54] = t16;
    $[55] = t7;
    $[56] = t8;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  return t17;
}
function _temp3(option_3) {
  return <SelectItem key={String(option_3.value)} value={String(option_3.value)} disabled={option_3.disabled} className={itemClassName}><OptionLabel imgUrl={option_3.imgUrl}>{option_3.label}</OptionLabel></SelectItem>;
}
function _temp2(option_2) {
  return <option key={String(option_2.value)} value={String(option_2.value)} disabled={option_2.disabled} className="bg-background text-foreground">{option_2.label}</option>;
}
function _temp() {
  const body = document.body;
  body.removeAttribute("data-scroll-locked");
}
export default Select;